import React, { Component } from 'react';
import PropTypes from "prop-types";

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class HorseRacingEarlyEntriesPage extends Component {
  static propTypes = {
    HorseRacingEarlyEntriesContainer: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      HorseRacingEarlyEntriesContainer,
    } = this.props;

    return (
      <div className="early-entries-page">
        <StandardPage sport="racing" title="Early Entries">
          <div className="main-layout-left-column">
            {HorseRacingEarlyEntriesContainer}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu",  "ocWidget"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingEarlyEntriesPage.js